module.exports = __webpack_public_path__ + "img/unnamed.f1603b8f.jpg";